import { asyncScriptLoader } from 'ember-simplepractice/utils/async-script-loader';
import { isEmberTesting } from 'ember-simplepractice/utils/is-testing';
import ENV from 'client-portal/config/environment';
import RecaptchaMock from '../mocks/recaptcha-mock';
import Service, { service } from '@ember/service';

export default class RecaptchaService extends Service {
  @service currentPractice;
  @service fastboot;

  get isFastBoot() {
    return this.fastboot?.isFastBoot || typeof window === 'undefined';
  }

  get #enterprise() {
    return window.grecaptcha?.enterprise;
  }

  async initialize() {
    if (this.isFastBoot) return;

    await this.#provisionRecaptcha();

    let sitekey = this.currentPractice.get('recaptchaSiteKey');

    if (typeof this.#enterprise?.ready === 'function') {
      this.#enterprise.ready(() => {
        this.#enterprise.render('recaptcha-container', { sitekey });
      });
    }
  }

  async #provisionRecaptcha() {
    if (!isEmberTesting() && ENV.railsEnv !== 'test') {
      await asyncScriptLoader('https://www.google.com/recaptcha/enterprise.js');
    } else {
      window.grecaptcha = { enterprise: new RecaptchaMock() };
    }
  }

  getResponse() {
    if (this.isFastBoot) return null;

    try {
      return this.#enterprise?.getResponse() ?? null;
    } catch (err) {
      // no op
    }
    return null;
  }

  async reset() {
    if (this.isFastBoot) return;

    try {
      if (typeof this.#enterprise?.reset === 'function') {
        this.#enterprise.reset();
      } else if (!this.#enterprise) {
        await this.initialize();
      }
    } catch (err) {
      // no op
    }
  }
}
